const paths: Record<string, string> = {
  dashboard: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
  upload: 'M5 21V3h10l4 4v14z M15 3v5h4 M12 17V11m-3 3 3-3 3 3',
  contracts: 'M3 6h7l2 3h9v12H3z M8 15l3 3 5-6',
  sales: 'M16 21v-3a4 4 0 0 0-8 0v3 M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M3 20v-3m18 3v-3',
  rights: 'M14 3a6 6 0 0 0-5 9L3 18v3h4v-3h3l3-4a6 6 0 1 0 1-11 M17 7h.01',
  reports: 'M5 3h10l4 4v14H5z M15 3v5h4 M8 14l3 3 5-6',
  ledger: 'M3 3h18v18H3z M8 3v18 M12 8h5 M12 12h5 M12 16h5',
  sync: 'M3 10a9 9 0 0 1 16-4l2 3 M21 3v6h-6 M21 14a9 9 0 0 1-16 4l-2-3 M3 21v-6h6',
  insights: 'M4 21v-7 M10 21v-11 M16 21V6 M22 21V2 M3 10l6-6 5 2 7-5',
  catalog: 'm12 2 10 5-10 5L2 7z M2 12l10 5 10-5 M2 17l10 5 10-5',
  diff: 'M3 3h18v18H3z M12 3v18',
  audit: 'm12 2 9 4v6c0 5-9 10-9 10S3 17 3 12V6z M8 12l3 3 5-6',
};
export function WorkspaceIcon({ name }: { name: string }) {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={paths[name] ?? paths.contracts} />
    </svg>
  );
}
